import { DS_setData, DS_getData } from '../DS/DS.Data'
import { Serv_send } from '../Serv/Serv.socketClient'
import { IDB_featureFlags } from '../IDB/IDB.dexie'
import { Logg_createLogger } from '../Logg/Logg.Logger'

/**
 * Includes syncing of anything that is specific to this customer:
 * eg. feature flags as different customers may have updated their server at different times
 */
export async function Cust_sync() {
    const logger = Logg_createLogger(`Cust_sync`)
    try {
        // Fetch the feature flags from the server
        const { features } = await Serv_send('info', {})

        // Check that the feature flags have changed
        const { featureFlags } = DS_getData()
        const newFlags = features.filter((x) => !featureFlags.includes(x))

        if (newFlags.length === 0) {
            logger.log('no new feature flags')
            return
        }

        // If so, update the data store
        DS_setData('FeatureFlagsUpdated', () => ({ featureFlags: features }))

        // And store in idb
        await IDB_featureFlags().set(features)

        logger.log(`feature flags saved to idb`)
    } catch (error) {
        logger.error(error)
    }
}
